import React from 'react';

import Text from 'components/Text';
import GlobalModal from 'modals/GlobalModal/GlobalModal';

interface ConfirmLogoutModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmLogoutModal: React.FC<ConfirmLogoutModalProps> = ({ open, onClose, onConfirm }) => {
  return (
    <GlobalModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      onCancel={onClose}
      confirmButtonText="Sair"
      cancelButtonText="Cancelar"
      title="CONFIRMAÇÃO"
    >
      <Text textAlign="left" size="medium" color="textPrimary">
        Deseja realmente sair da plataforma?
      </Text>
    </GlobalModal>
  );
};

export default ConfirmLogoutModal;
